import { i18n } from '@/locales';
import { RouteRecordRaw } from 'vue-router';
import { RouteNames } from './types';

const { t } = i18n.global;

// TODO: Consider whether any static content here should be localised
export const routes: RouteRecordRaw[] = [
  {
    path: '',
    name: RouteNames.Hazards,
    component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
    children: [
      {
        path: ':hazardType',
        name: RouteNames.HazardByType,
        component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
      },
      {
        path: ':hazardType/:hazardId',
        name: RouteNames.HazardById,
        component: () => import('@/features/hazards/presentation/views/Hazards.vue'),
        meta: { title: t('5AzAnIWD8v-rS-P4UMU7V') },
      },
    ],
    meta: {
      title: t('VbZboInmvh8gEfK6qvL50'),
    },
  },
  {
    path: '/text-version',
    name: RouteNames.TextVersion,
    component: () => import('@/features/hazards/presentation/views/HazardTextVersion.vue'),
    meta: {
      title: t('9m1OXpvYB8xDIwUVHv-5R'),
      description: t('-OdqxVnWcAbGwXlJWlbDc'),
    },
  },
  {
    path: '/text-version/:hazardType/:hazardId',
    name: RouteNames.TextVersionById,
    component: () => import('@/features/hazards/presentation/views/HazardTextSingle.vue'),
    meta: {
      title: t('9m1OXpvYB8xDIwUVHv-5R'),
      description: t('-OdqxVnWcAbGwXlJWlbDc'),
    },
  },
  {
    path: '/about',
    component: () => import('@/common/views/about/About.vue'),
    meta: {
      title: t('1a7LOuqd0nGD2JxQBAq2-'),
      description: t('Hst470iFuHUdGLON_tysv'),
    },
  },
  {
    path: '/map-icons',
    component: () => import('@/features/hazards/presentation/views/MapIcons.vue'),
    meta: {
      title: t('aisctzGcqdVzSG_PCYZ5G'),
    },
  },
  {
    path: '/map-guide',
    component: () => import('@/features/hazards/presentation/views/MapGuide.vue'),
    meta: {
      title: t('S25XURdwO7t2iloBvNX4I'),
    },
  },
  {
    path: '/:pathMatch(.*)',
    redirect: {
      name: RouteNames.Hazards,
    },
  },
  {
    path: '/faq',
    component: () => {},
    meta: {
      title: t('_YuYh6TojvigalDAoNPgz'),
      description: t('Kxekkepu42aR5uPOPe2k1'),
    },
  },
  {
    path: '/language',
    component: () => import('@/common/components/UiLanguageToggle/UiLanguagePage.vue'),
    meta: {
      title: t('OREVkEvR7JiEostpW7_uY'),
      description: t('i6rYouqR2spCrYFK2jCz2'),
    },
  },
];
